import Vue from 'vue'
import Vuex from 'vuex'
import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from './config/oidc'
//import { parse } from '@fortawesome/fontawesome-svg-core'

Vue.use(Vuex)

const nsClaim = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/";

var parseJwt = function parseJwt(token) {
    try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    } catch (error) {
        return {};
    }
};
var tokenExp = function tokenExp(token) {
    if (token) {
        var parsed = parseJwt(token);
        return parsed.exp ? parsed.exp * 1000 : null;
    }

    return null;
};
var tokenIsExpired = function tokenIsExpired(token) {
    var tokenExpiryTime = tokenExp(token);

    if (tokenExpiryTime) {
        return tokenExpiryTime < new Date().getTime();
    }

    return false;
};

export default new Vuex.Store({
    state: {
        username: "",
        userProfile: [],
        loggedInUserAssociatedAccount: null,
        searchedUserDetail: null,
        isPageloaded: false,
        errorMessage: `<ul>
        <li>USA - (1) 800.826.8028</li>
        <li>EMEA - (00) 800.150.03000</li>
        <li>APAC - (+) 800.000.09999</li>
        </ul>`,
        accountIdsHash: "",
        accountHierarchy: {},
        primaryAccount: "",
        loggedInUserAdfsGuid: "",
        adminAccounts: [],
        languagePreference:[],
        apiCallCount: 0,
        isApiRequested: false,
        permissions: [],
        roles: [],
        accessibleApplication: [],
        isPageDirty: false,
        isFirstLoadCompleted: false,
        isUserImpersonated: false,
        isImpersonation: false
    },
    mutations: {
        setLoggedInUserAccount(state, user) {
            if (state.loggedInUserAssociatedAccount == null)
                state.loggedInUserAssociatedAccount = user
        },
        setPageLoadedValue(state, isPageloaded) {
            state.isPageloaded = isPageloaded;
        },
        setSearchedUserDetail(state, user) {
            state.searchedUserDetail = user
        },
        setErrorMessage(state, message) {
            state.errorMessage = message
        },
        setAccountIdsHash(state, message) {
            state.accountIdsHash = message
        },
        setAccountHierarchy(state, message) {
            state.accountHierarchy = message
        },
        setPrimaryAccount(state, message) {
            state.primaryAccount = message
        },
        setLoggedInUserAdfsGuid(state, message) {
            state.loggedInUserAdfsGuid = message;
        },
        setAdminAccounts(state, message) {
            state.adminAccounts = message;
        },
        setLanguagePreference(state, message) {
            state.languagePreference = message;
        },
        triggerSilentLogin(state) {
            state.apiCallCount++;
            state.isApiRequested = true;
        },
        resetIsApiRequested(state) {
            state.isApiRequested = false;
        },
        addPermissions(state, message) {
            state.permissions.push(message);
        },
        addRoles(state, message) {
            state.roles.push(message);
        },
        setIsPageDirty(state, message) {
            state.isPageDirty = message;
        },
        addAccessibleApplication(state, message) {
            state.accessibleApplication.push(message);
        },
        setFirstLoadCompleted(state) {
            state.isFirstLoadCompleted = true;
        },
        setIsUserImpersonated(state, message) {
            state.isUserImpersonated = message;
        }
    },
    actions: {
        setUserDetails({ commit }, user) {
            commit('setUserDetails', user);
        },
        setPageLoadedValue({ commit }, isPageloaded) {
            commit('setPageLoadedValue', isPageloaded);
        },
        setLoggedInUserAccount({ commit }, user) {
            commit('setLoggedInUserAccount', user);
        },
        setSearchedUserDetail({ commit }, user) {
            commit('setSearchedUserDetail', user);
        },
        setErrorMessage({ commit }, message) {
            commit('setErrorMessage', message);
        },
        setAccountIdsHash({ commit }, message) {
            commit('setAccountIdsHash', message);
        },
        setAccountHierarchy({ commit }, message) {
            commit('setAccountHierarchy', message);
        },
        setPrimaryAccount({ commit }, message) {
            commit('setPrimaryAccount', message);
        },
        setLoggedInUserAdfsGuid({ commit }, message) {
            commit('setLoggedInUserAdfsGuid', message);
        },
        setAdminAccounts({ commit }, message) {
            commit('setAdminAccounts', message);
        },
        setLanguagePreference({ commit }, message) {
            commit('setLanguagePreference', message);
        },
        triggerSilentLogin({ commit }) {
            commit('triggerSilentLogin');
        },
        resetIsApiRequested({ commit }) {
            commit('resetIsApiRequested');
        },
        addPermissions({ commit }, message) {
            commit('addPermissions', message);
        },
        addRoles({ commit }, message) {
            commit('addRoles', message);
        },
        setIsPageDirty({ commit }, message) {
            commit('setIsPageDirty', message);
        },
        addAccessibleApplication({ commit }, message) {
            commit('addAccessibleApplication', message);
        },
        setFirstLoadCompleted({ commit }) {
            commit('setFirstLoadCompleted');
        },
        setIsUserImpersonated({ commit }, message) {
            commit('setIsUserImpersonated', message);
        }
    },
    getters: {
        isImpersonation(state) {
            return state.isImpersonation;
        },
        isUserImpersonated(state) {
            let zImpersonatedUser = "";
            for (var prop in state.oidcStore.user) {
                let key = prop.replace(nsClaim, "");
                if (key == "zImpersonatedUser") {
                    zImpersonatedUser = state.oidcStore.user[prop]
                }
            }
            return zImpersonatedUser != "";
        },
        isAccountImpersonated(state) {
            let zImpersonatedAccount = "";
            for (var prop in state.oidcStore.user) {
                let key = prop.replace(nsClaim, "");
                if (key == "zImpersonatedAccount") {
                    zImpersonatedAccount = state.oidcStore.user[prop]
                }
            }
            return zImpersonatedAccount != "";
        },
        impersonatedAccount(state) {
            let zImpersonatedAccount = "";
            for (var prop in state.oidcStore.user) {
                let key = prop.replace(nsClaim, "");
                if (key == "zImpersonatedAccount") {
                    state.isImpersonation = true;
                    zImpersonatedAccount = state.oidcStore.user[prop]
                }
            }
            return zImpersonatedAccount;
        },
        username(state) {
            let username = "";
            let zImpersonatedUser = "";
            for (var prop in state.oidcStore.user) {
                let key = prop.replace(nsClaim, "");
                if (key == "name") {
                    username = state.oidcStore.user[prop];
                }
                if (key == "zImpersonatedUser") {
                    state.isImpersonation = true;
                    zImpersonatedUser = state.oidcStore.user[prop]
                }
            }
            return zImpersonatedUser == "" ? username : zImpersonatedUser.split('|')[0];
        },
        emailAddress(state) {
            let email = "";
            for (var prop in state.oidcStore.user) {
                let key = prop.replace(nsClaim, "");
                if (key == "emailaddress") {
                    email = state.oidcStore.user[prop];
                }
            }
            return email;
        },
        isPageloaded(state) {
            return state.isPageloaded;
        },
        loggedInUserAssociatedAccount(state) {
            return state.loggedInUserAssociatedAccount;
        },
        searchedUserDetail(state) {
            return state.searchedUserDetail;
        },
        oidcIdToken(state) {
            return tokenIsExpired(state.oidcStore.id_token) ? null : state.oidcStore.id_token;
        },
        errorMessage(state) {
            return state.errorMessage;
        },
        accountIdsHash(state) {
            return state.accountIdsHash;
        },
        accountHierarchy(state) {
            return state.accountHierarchy;
        },
        primaryAccount(state) {
            return state.primaryAccount;
        },
        loggedInUserAdfsGuid(state) {
            return state.loggedInUserAdfsGuid;
        },
        adminAccounts(state) {
            return state.adminAccounts;
        },
        languagePreference(state) {
            return state.languagePreference;
        },
        apiCallCount(state) {
            return state.apiCallCount;
        },
        isApiRequested(state) {
            return state.isApiRequested;
        },
        permissions(state) {
            return state.permissions;
        },
        roles(state) {
            return state.roles;
        },
        isPageDirty(state) {
            return state.isPageDirty;
        },
        accessibleApplication(state) {
            return state.accessibleApplication;
        },
        isFirstLoadCompleted(state) {
            return state.isFirstLoadCompleted;
        }
    },
    modules: {
        oidcStore: vuexOidcCreateStoreModule(
            oidcSettings,
            {
                namespaced: true,
                dispatchEventsOnWindow: true
            },
            {
                //userLoaded: (user) => console.log('OIDC user is loaded:', user),
                //userUnloaded: () => console.log('OIDC user is unloaded'),
                //accessTokenExpiring: () => console.log('Access token will expire'),
                //accessTokenExpired: () => console.log('Access token did expire'),
                //silentRenewError: () => console.log('OIDC user is unloaded'),
                //userSignedOut: () => console.log('OIDC user is signed out')
            }
        )
    }
})
